import { useTranslation } from "react-i18next"

/** Logo mark + Arabic name (spec §4.1). The green half keeps its colour; the dark half follows the text colour (dark mode). */
export function BrandMark({ width = 44, height = 27 }: { width?: number; height?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="128 125 144 87"
      width={width}
      height={height}
      aria-hidden
      className="shrink-0 text-ink"
    >
      <path fill="#4cac34" fillRule="evenodd" d={GREEN} />
      <path fill="currentColor" fillRule="evenodd" d={DARK} />
    </svg>
  )
}

const GREEN =
  "M134.207 156.042 L 134.250 180.417 134.800 181.583 C 135.575 183.227,156.896 204.626,158.607 205.478 C 160.244 206.292,160.890 206.331,172.792 206.332 L 183.833 206.333 183.833 193.833 L 183.833 181.333 172.372 181.333 C 159.372 181.333,160.100 181.408,159.375 179.994 L 159.000 179.263 159.000 155.465 L 159.000 131.667 146.582 131.667 L 134.163 131.667 134.207 156.042 M204.308 168.292 C 193.284 179.340,192.507 180.157,191.980 181.250 L 191.417 182.417 191.371 194.375 L 191.325 206.333 203.746 206.333 L 216.167 206.333 216.167 181.417 C 216.167 167.712,216.146 156.500,216.120 156.500 C 216.094 156.500,210.779 161.806,204.308 168.292 Z"
const DARK =
  "M183.833 156.541 L 183.833 181.416 195.674 169.583 C 206.345 158.919,207.567 157.643,208.049 156.667 L 208.583 155.583 208.630 143.625 L 208.677 131.667 196.255 131.667 L 183.833 131.667 183.833 156.541 M216.167 144.167 L 216.167 156.667 227.675 156.667 C 240.346 156.667,239.753 156.619,240.529 157.706 L 240.917 158.250 240.961 182.292 L 241.004 206.333 253.419 206.333 L 265.833 206.333 265.833 182.193 C 265.833 155.227,265.919 157.220,264.690 155.461 C 263.689 154.029,242.315 132.899,241.417 132.454 C 239.873 131.690,239.463 131.667,227.492 131.667 L 216.167 131.667 216.167 144.167 Z"

export function BrandLockup({ compact = false }: { compact?: boolean }) {
  const { t } = useTranslation()
  return (
    <div className="flex items-center gap-3">
      <BrandMark />
      {!compact && (
        <div className="leading-tight">
          <div className="text-[17px] font-bold">{t("app.name")}</div>
          <div className="text-[13px] text-muted-foreground">{t("app.tagline")}</div>
        </div>
      )}
    </div>
  )
}
